import { Cable, KeyRound, PlugZap, Activity } from 'lucide-react';
import { Button } from 'components/ui/button';
import { connectionStatus } from './McpAPI';

const date = (value) =>
    value
        ? new Date(Number(value)).toLocaleString(undefined, {
              dateStyle: 'medium',
              timeStyle: 'short',
          })
        : 'Not used yet';

export function ConnectionList({ connections, enabled, onRevoke }) {
    const activeCount = connections.filter(
        (item) => connectionStatus(item, enabled) === 'Active',
    ).length;
    return (
        <section className="mcp-panel">
            <div className="mcp-section-heading">
                <div>
                    <h2>
                        Connections <span className="mcp-count">{connections.length}</span>
                    </h2>
                    <p>{activeCount} active · Access across all Frontdoor organizations</p>
                </div>
                <PlugZap size={20} className="mcp-muted" />
            </div>
            {connections.length === 0 ? (
                <div className="mcp-empty">
                    <div className="mcp-empty-icon">
                        <Cable size={28} />
                    </div>
                    <h3>Your next teammate starts here.</h3>
                    <p>
                        Add the server URL in your AI app, then approve its access in Frontdoor.
                        Prefer a key? Create one above.
                    </p>
                    <span>Dots · Grok Bot · MCP clients</span>
                </div>
            ) : (
                <div className="mcp-connection-list">
                    {connections.map((item) => {
                        const status = connectionStatus(item, enabled);
                        const usable = status === 'Active' || status === 'Paused';
                        return (
                            <article className="mcp-connection" key={item.id}>
                                <div className="mcp-avatar">
                                    {item.kind === 'oauth' ? (
                                        <Cable size={19} />
                                    ) : (
                                        <KeyRound size={19} />
                                    )}
                                </div>
                                <div className="mcp-connection-info">
                                    <div className="mcp-connection-title">
                                        <h3>{item.label}</h3>
                                        <span
                                            className={`mcp-badge ${status === 'Active' ? 'is-active' : ''}`}
                                        >
                                            {status}
                                        </span>
                                    </div>
                                    <p>
                                        {item.kind === 'oauth' ? 'OAuth' : 'Access key'} · Created
                                        by {item.created_by_name || 'an administrator'}
                                    </p>
                                    <div className="mcp-connection-meta">
                                        <span>Last used: {date(item.last_used_at)}</span>
                                        <span>Expires: {date(item.expires_at)}</span>
                                    </div>
                                </div>
                                {usable && (
                                    <Button
                                        variant="ghost"
                                        size="sm"
                                        onClick={() => onRevoke(item)}
                                        aria-label={`Revoke ${item.label}`}
                                    >
                                        Revoke
                                    </Button>
                                )}
                            </article>
                        );
                    })}
                </div>
            )}
        </section>
    );
}

export function McpActivity({ activity }) {
    return (
        <section className="mcp-panel mcp-activity">
            <div className="mcp-section-heading">
                <div>
                    <h2>Recent activity</h2>
                    <p>Tool calls and access changes. Customer data is kept out of this log.</p>
                </div>
                <Activity size={20} className="mcp-muted" />
            </div>
            {activity.length === 0 ? (
                <p className="mcp-activity-empty">
                    Activity will appear when you connect an app or change access.
                </p>
            ) : (
                <div className="mcp-table-scroll">
                    <table>
                        <thead>
                            <tr>
                                <th>Action</th>
                                <th>Connection / admin</th>
                                <th>Result</th>
                                <th>Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {activity.map((item) => (
                                <tr key={item.id}>
                                    <td>
                                        <code>{item.action}</code>
                                    </td>
                                    <td>{item.connection_label || item.actor_name || '—'}</td>
                                    <td>
                                        <span
                                            className={`mcp-outcome ${item.outcome === 'success' ? '' : 'is-denied'}`}
                                        >
                                            {item.outcome === 'success' ? 'Allowed' : 'Blocked'}
                                        </span>
                                    </td>
                                    <td>{date(item.created_at)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            <footer className="mcp-panel-footer">
                Latest 50 entries · Refreshes every 15 seconds
            </footer>
        </section>
    );
}
